<template>
  <component
    :is="is"
    :aria-disabled="disabled"
    :aria-label="active && label ? `${label} (current)` : label"
    :aria-selected="active"
    :class="[
      classes[variant],
      sizes[size],
      { active, disabled, loading },
    ]"
    :title="title"
    v-bind="{ 'a': { href, rel, target }, 'button': { disabled, type } }[is]"
    @click.capture.stop="click"
  >
    <slot/>
    <icon v-if="loading" name="loading"/>
    <icon v-else-if="icon" :name="icon"/>
    <span v-if="active && !label" class="sr-only">(current)</span>
  </component>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import { computed } from "vue"
import { loginPopup } from "@/login-popup"
import { useAuth } from "@/composables/useAuth"

const props = defineProps({
  active: Boolean,
  ariaLabel: String,
  disabled: Boolean,
  href: String,
  icon: String,
  loading: Boolean,
  title: String,
  requiresAuth: Boolean,
  rel: String,
  size: String,
  target: String,
  type: { type: String, default: "button" },
  variant: String,
})

const emit = defineEmits(["click"])

const { user } = useAuth()

const active = computed(() => {
  return props.active || null
})

const classes = {
  primary: "btn btn-primary",
  secondary: "btn btn-secondary",
  light: "btn btn-light",
  link: "btn btn-link",
  danger: "btn btn-danger",
  outline: "btn btn-outline",
  white: "btn btn-white",
}

const sizes = {
  sm: "btn-sm",
  md: "btn-md",
  lg: "btn-lg",
  xl: "btn-xl",
}

const disabled = computed(() => {
  return props.disabled || props.loading ? true : null
})

const is = computed(() => {
  return props.href && !disabled.value && !unauthorized.value ? "a" : "button"
})

const label = computed(() => {
  return props.ariaLabel || props.title
})

const unauthorized = computed(() => {
  return props.requiresAuth && !user.value
})

const click = (event) => {
  if (unauthorized.value) {
    loginPopup()

    return
  }

  emit("click", event)
}
</script>
